import { Box, Grid, TextField } from "@material-ui/core";
import { useState } from "react";
import { useDispatch } from "react-redux";

import { useAppSelector } from "../../app/hooks";
import { ZIPCODE_REGEX } from "../../Constants";
import { CxQuestion } from "../../entity/entities";
import { changeFreeText } from "./PreviewReducer";
import { QuestionText } from "../question/QuestionText";
import { useTranslation } from "react-i18next";

export const Zipcode = (props: {
  pageIndex: number;
  questionIndex: number;
  cxQuestion: CxQuestion;
}) => {
  const [errorMessage, setErrorMessage] = useState(``);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { pageIndex, questionIndex, cxQuestion } = props;

  const answerStr = useAppSelector((state) => {
    const cxQuestionPage = state.preview.answer[pageIndex];
    const cxQuestion = cxQuestionPage.cxAnswers[questionIndex];

    return cxQuestion.answerStr;
  });

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const zipcode = event.target.value;
    setErrorMessage(``);

    if (zipcode && !ZIPCODE_REGEX.test(zipcode))
      setErrorMessage(t('preview.enter_7_digit_number_without_hyphens'));

    dispatch(
      changeFreeText({
        pageIndex,
        questionIndex,
        str: zipcode,
      })
    );
  };

  return (
    <>
      <QuestionText cxQuestion={cxQuestion} />
      <Box mx={4}>
        <Grid container>
          <Grid item xs={8}>
            <TextField
              fullWidth
              variant="outlined"
              value={answerStr}
              onChange={handleChange}
              inputProps={{ maxLength: 7 }}
              placeholder={t('preview.seven_digit_number_no_hyphens')}
            />
          </Grid>
          <Grid item xs={4} />
        </Grid>

        {errorMessage && (
          <Grid container>
            <span style={{ color: `red` }}>{errorMessage}</span>
          </Grid>
        )}
      </Box>
    </>
  );
};
